import { createNursingPortalPaths } from '../nurse/nursePaths';
import { MAJOR_COPY } from './majorCopy';

export const MAJOR_BASE = '/major';

const NURSING_PATHS = createNursingPortalPaths(MAJOR_BASE);

export const MAJOR_PATHS = {
  ...NURSING_PATHS,
  SOINS: `${MAJOR_BASE}/soins-infirmerie`,
  INJECTION: `${MAJOR_BASE}/injections`,
  TESTS: `${MAJOR_BASE}/tests-infirmerie`,
  VACCINS: `${MAJOR_BASE}/vaccins`,
  PLANNING_FAMILIAL: `${MAJOR_BASE}/planning-familial`,
  RAPPORTS: `${MAJOR_BASE}/rapports`,
  RAPPORTS_SOINS: `${MAJOR_BASE}/rapports/soins`,
  RAPPORTS_INJECTIONS: `${MAJOR_BASE}/rapports/injections`,
  RAPPORTS_TESTS: `${MAJOR_BASE}/rapports/tests`,
  RAPPORTS_VACCINS: `${MAJOR_BASE}/rapports/vaccins`,
  RAPPORTS_PLANNING_FAMILIAL: `${MAJOR_BASE}/rapports/planning-familial`
};

const REPORTS_NAV = {
  to: MAJOR_PATHS.RAPPORTS,
  end: false,
  label: MAJOR_COPY.NAV.reports.label,
  hint: MAJOR_COPY.NAV.reports.hint,
  icon: 'chartBar'
};

const CATALOG_NAV = [
  {
    to: MAJOR_PATHS.SOINS,
    end: false,
    label: MAJOR_COPY.NAV.catalogSoins.label,
    hint: MAJOR_COPY.NAV.catalogSoins.hint,
    icon: 'heart',
    group: 'catalog'
  },
  {
    to: MAJOR_PATHS.TESTS,
    end: false,
    label: MAJOR_COPY.NAV.catalogTests.label,
    hint: MAJOR_COPY.NAV.catalogTests.hint,
    icon: 'check',
    group: 'catalog'
  },
  {
    to: MAJOR_PATHS.INJECTION,
    end: false,
    label: MAJOR_COPY.NAV.catalogInjection.label,
    hint: MAJOR_COPY.NAV.catalogInjection.hint,
    icon: 'syringe',
    group: 'catalog'
  },
  {
    to: MAJOR_PATHS.VACCINS,
    end: false,
    label: MAJOR_COPY.NAV.catalogVaccins.label,
    hint: MAJOR_COPY.NAV.catalogVaccins.hint,
    icon: 'shield',
    group: 'catalog'
  },
  {
    to: MAJOR_PATHS.PLANNING_FAMILIAL,
    end: false,
    label: MAJOR_COPY.NAV.catalogPlanningFamilial.label,
    hint: MAJOR_COPY.NAV.catalogPlanningFamilial.hint,
    icon: 'users',
    group: 'catalog'
  }
];

export function getMajorCatalogNavItems() {
  return CATALOG_NAV;
}

export function getMajorExtraNavItems() {
  return [REPORTS_NAV, ...CATALOG_NAV];
}
